module.exports = __webpack_public_path__ + "1de7a4fc.png";